<div class="app-page-container">

  <div *ngIf="waitOnInit" class="d-flex app-text-success justify-content-center align-items-center">
    <span class="spinner-border spinner-border-sm mr-1"></span>
    Loading Users...
  </div>

  <!-- USER LIST -->
  <section *ngIf="!waitOnInit && currentView('defaultView')">
    <div class="d-flex align-items-center justify-content-between flex-wrap">
      <h1 class="mb-3 mr-3" style="line-height: 1">
        Users
      </h1>
      <div class="d-flex gap-2">
        <button class="btn app-btn-secondary mb-3 mr-2" type="button" (click)="onSelectView('createUserForm')"
              [disabled]="noSecurityGroups || waitOnAction">
          Create New
        </button>
        <button class="btn app-btn-secondary mb-3" type="button" (click)="showInactiveUsers = !showInactiveUsers" [disabled]="waitOnAction">
          {{showInactiveUsers ? 'Show Active' : 'Show Inactive'}}
        </button>
      </div>
    </div>

    <!-- SEARCH -->
    <form [formGroup]="searchForm" class="input-group mb-3">
      <div class="input-group-prepend">
        <button class="btn app-btn-success" style="z-index:0" type="submit" (click)="onSearch(searchForm.value)">
          Search
        </button>
      </div>
      <input class="form-control" formControlName="name" type="text" [maxlength]="REQS.maxLength.standard"
             placeholder="by name" required/>
      <div class="input-group-append">
        <button *ngIf="searchActive()" class="btn app-btn-neutral" type="button" (click)="onClearSearch()">
          Clear
        </button>
      </div>
    </form>

    <!-- FILTER BY SECURITY GROUP -->
    <!-- <div *ngIf="users.length > 0" class="input-group mb-3">
      <div class="d-flex align-items-start">
        <p class="mt-auto mb-auto" style="font-weight: bold">Security&nbsp;Groups:</p>
        <div class="d-flex flex-wrap">
          <div *ngFor="let group of securityGroupFilterOptions; let i = index;"
            class="d-flex align-items-center pl-3 pr-3">
            <span class="pr-2">{{group.name}}</span>
            <input type="checkbox" checked="group.selected" (click)="toggleSelectSecurityGroup(i)">
          </div>
        </div>
      </div>
    </div> -->

    <article *ngFor="let user of users; let i = index" class="mb-3"
             [ngClass]="{ 'd-none': !searchMatch(user) }">
      <app-user-card
        *ngIf="!!user.deletedAt == showInactiveUsers"
        [user]="user"
        [waitOnAction]="waitOnAction"
        [noSecurityGroups]="noSecurityGroups"
        (edit)="onSelectEditTarget($event)"
        (delete)="deleteUser($event)"
        (restore)="restoreUser($event)"
      ></app-user-card>
    </article>
  </section>

  <!-- CREATE USER -->
  <section *ngIf="currentView('createUserForm')">
    <div class="d-flex align-items-center justify-content-between flex-wrap">
      <h1 class="mb-3 mr-3" style="line-height: 1">
        Create User
      </h1>
      <button class="btn app-btn-neutral mb-3" type="button" (click)="onSelectView('defaultView')">
        Cancel
      </button>
    </div>

    <app-user-form [securityGroups]="securityGroups" [waitOnAction]="waitOnAction" (createUser)="createUser($event)">
    </app-user-form>
  </section>

  <!-- EDIT USER -->
  <section *ngIf="currentView('editUserForm')">
    <div class="d-flex align-items-center justify-content-between flex-wrap">
      <div class="d-flex align-items-center mb-3 mr-3">
        <h1 class="mr-3 mb-0" style="line-height: 1">
          Edit User
        </h1>
        <span class="badge badge-dark">{{'USER ID: ' + currentEditTarget.id + ''}}</span>
      </div>
      <button class="btn app-btn-neutral mb-3" type="button" (click)="onCancelEditTarget()">
        Cancel
      </button>
    </div>

    <app-user-form [securityGroups]="securityGroups" [editTarget]="currentEditTarget" [waitOnAction]="waitOnAction"
                   (editUser)="editUser($event)">
    </app-user-form>
  </section>

</div>
